// import counterUp from 'counterup2'

import { elementScrollIntoView } from 'seamless-scroll-polyfill'

document.onreadystatechange = () => {

    if ( document.readyState === 'complete' ) {

        const viewport = window.innerWidth
        const scrollTo = document.querySelectorAll('.js-scroll-to')

        const deliveriesCart = document.querySelectorAll('.js-cart-delivery-step')
        const paymentsCart   = document.querySelectorAll('.js-cart-payment-step')

        if ( deliveriesCart && paymentsCart ) {

            deliveriesCart.forEach( delivery => {
                delivery.addEventListener('click', function (e) {
                    let payments = JSON.parse(this.getAttribute('data-allowed-payments'))

                    if ( !this.getAttribute('data-canceled') ) {
                        paymentsCart.forEach( payment => {

                            payment.setAttribute('data-canceled', true)
                            payment.children[0].children[0].checked = false

                            if ( !payments.includes(payment.getAttribute('data-id')) )
                                payment.style.display = 'none'
                            else
                                payment.style.display = 'flex'
                        })
                    }
                })
            })

            paymentsCart.forEach( payment => {
                payment.addEventListener('click', function (e) {
                    let id = this.getAttribute('data-id')

                    if ( !this.getAttribute('data-canceled') ) {
                        deliveriesCart.forEach( delivery => {
                            delivery.setAttribute('data-canceled', true)
                            delivery.children[0].children[0].checked = false
                            let payments = JSON.parse(delivery.getAttribute('data-allowed-payments'))

                            if ( payments.includes(id) )
                                delivery.style.display = 'flex'
                            else
                                delivery.style.display = 'none'
                        })
                    }
                })
            })
        }

        if ( scrollTo ) {

            scrollTo.forEach( item => {
                item.addEventListener('click', function (e) {
                    e.preventDefault()

                    let target = item.getAttribute('href')

                    if ( isSafari() && isIos() ) {
                        elementScrollIntoView(
                            document.getElementById(target.replace('#', '')),
                            {
                                behavior: 'smooth',
                                block: 'center'
                            }
                        );
                    } else {
                        document.getElementById(target.replace('#', ''))
                            .scrollIntoView({
                                behavior: 'smooth',
                                block: 'center'
                            })
                    }
                })
            })
        }

        const formInputs   = document.querySelectorAll('form input:not(.filter-input)')
        const formTextarea = document.querySelectorAll('form textarea')
        const formSelects  = document.querySelectorAll('form select')

        if ( formInputs || formTextarea ) {

            if ( formInputs )
                formInputs.forEach( item => checkFormElementIfFilled(item))

            if ( formTextarea )
                formTextarea.forEach( item => checkFormElementIfFilled(item))

            if ( formSelects )
                formSelects.forEach( item => checkFormElementIfFilled(item))

            function checkFormElementIfFilled(formEl) {
                if ( formEl.value !== '' ) formEl.classList.add('filled')
            }
        }

        const imageOffsetCalc = document.querySelector('.js-calc-offset')

        if ( imageOffsetCalc ) {

            if ( viewport > 991 ) {
                imageOffsetCalc.style.marginRight = parseFloat('-'+ right(imageOffsetCalc).toString())+'px'
            }

            window.addEventListener('resize', function () {
                if ( this.innerWidth > 991 ) {
                    imageOffsetCalc.style.marginRight = parseFloat('-'+ right(imageOffsetCalc).toString())+'px'
                }
            })
        }

        const toggleFirmInputs = document.getElementById('js-firm-inputs')
        const addressToggle    = document.getElementById('js-address-toggle')

        if ( toggleFirmInputs ) {

            toggleFirmInputs.addEventListener('click', function () {
                this.classList.toggle('open')
                document.getElementById('firm-inputs').classList.toggle('show')
            })
        }

        if ( addressToggle ) {
            const deliveryInputs = document.getElementById('delivery-inputs')

            if ( addressToggle.checked )
                deliveryInputs.style.display = 'none'

            addressToggle.addEventListener('change', function () {
                if ( this.checked )
                    deliveryInputs.style.display = 'none'
                else
                    deliveryInputs.style.display = 'block'
            })
        }

        if ( viewport < 991 ) {
            const fixedFilter = document.getElementById('js-fixed-filter')

            if ( fixedFilter ) {
                window.addEventListener('scroll', debounce(function () {
                    if ( window.scrollY > 400 ) fixedFilter.classList.add('visible')
                    else fixedFilter.classList.remove('visible')
                }, 50))
            }
        }

        const mediaBanner = document.querySelector('section.media-banner')

        if ( mediaBanner ) {

            if ( viewport < 576 ) {
                let mobileImage = mediaBanner.getAttribute('data-mobile-image')

                mediaBanner.style.backgroundImage = 'url('+ mobileImage +')';
            }
        }

        const zoomSlider = document.querySelector('#zoom .splide')

        if ( zoomSlider && viewport > 767 ) {

            let image = document.querySelectorAll('#zoom .splide .image-wrapper')

            image.forEach( (item) => {
                item.addEventListener('mousemove', (e) => {
                    zoom(e)
                    item.style.backgroundImage = 'url('+ item.childNodes[0].getAttribute('src') +')'
                })

                item.addEventListener('mouseleave', (e) => {
                    item.style.backgroundImage = ''
                })
            })
        }
    }

    function zoom(e) {
        let zoomer  = e.currentTarget,
            offsetX = null,
            offsetY = null;

        e.offsetX ? offsetX = e.offsetX : offsetX = e.touches[0].pageX
        e.offsetY ? offsetY = e.offsetY : offsetX = e.touches[0].pageX

        let x = offsetX/zoomer.offsetWidth*100,
            y = offsetY/zoomer.offsetHeight*100

        zoomer.style.backgroundPosition = x + '% ' + y + '%';
    }

    function isSafari() {
        return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
    }

    function isIos() {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    }

    function right(element) {
        return window.innerWidth - (element.getBoundingClientRect().left + element.offsetWidth)
    }

    function debounce(func, timeout = 300){
        let timer;

        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => { func.apply(this, args); }, timeout);
        };
    }

    function toggleVisibility(el) {

        if ( el.style.display === 'block' )
            el.style.display = 'none';
        else
            el.style.display = 'block';
    }
};
